import React from 'react'

export default function visionAndMessage() {
    return (
        <div className="container-fluid rtl">
            <h1 className="block-title text-center title mb-5 mt-5">
                رؤية ورسالة هاد </h1>

            <div className="row  py-5 ">
                <div className="container">
                    <div className="row ">
                        <div className="col-12 col-md-6 mb-5 mb-md-0">
                            <div className="vision-card ">
                                <h2 className=" ">رؤيتنا</h2>
                                <p>تقديم خدمات إسنادية وحلول استشارية للمشاريع المتوسطة والصغيرة.
                    </p>
                                <img src="https://i.ibb.co/LPf7s04/arrow.png" className="img-fluid ml-auto mt-auto" alt="arrow" />
                            </div>

                        </div>
                        {/*  <div className="col-12 col-md-4">
                    <div className="had-card">
                    <img src="https://i.ibb.co/cLfcQf7/LOGO2.png" className="img-fluid"/>
                    </div>
                    
                </div> */}
                        <div className="col-12 col-md-6">
                            <div className="message-card">
                                <h2 className="">رسالتنا</h2>
                                <p>أن نكون من أوائل الشركات الرائدة في قطاع إسناد الخدمات، وتسريع الأعمال.
                                </p>
                                <img src="https://i.ibb.co/LPf7s04/arrow.png" className="img-fluid " alt="arrow" />
                            </div>

                        </div>
                    </div>
                    {/*  <div className="col-12 col-md-4 mx-auto">
                         <div className="perspective-text">
                            <div className="perspective-line">
                                <p></p>
                                <p>رؤية</p>
                            </div>
                            <div className="perspective-line">
                                <p>رؤية</p>
                                <p>و</p>
                            </div>
                            <div className="perspective-line">
                                <p>و</p>
                                <p>رسالة</p>
                            </div>
                            <div className="perspective-line">
                                <p>رسالة</p>
                                <p>هاد</p>
                            </div>
                            <div className="perspective-line">
                                <p>هاد</p>
                                <p></p>
                            </div>
                    </div>
                    </div> */}
                    {/*  <div className="row">
                    <div className="col-12 col-md-4 order-1 order-md-0">
                    <div className="twenty-thirty-p text-center">
                    <p>أن نكون من أوائل الشركات الرائدة في قطاع إسناد الخدمات، وتسريع الأعمال.
                    </p>
                    </div>
                    </div>
                    <div className="d-none d-md-block col-md-3 mx-auto my-auto ">
                    <img src="https://i.ibb.co/RNSbdGp/rotated-right-arrow-pngrepo-com.png" className="img-fluid"/>
                    </div>
                    <div className="col-12 col-md-4 ml-auto my-auto order-0 order-md-2 ">
                    
                    <h2 className="message-title ">رؤيتنا</h2>
                    
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-12 col-md-4 order-1 order-md-2">
                    <div className="twenty-thirty-p text-center">
                    <p>تقديم خدمات إسنادية وحلول استشارية للمشاريع المتوسطة والصغيرة.
                    </p>
                    </div>
                    </div>
                    <div className="d-none d-md-block col-md-3 mx-auto my-auto flip-img order-md-1">
                    <img src="https://i.ibb.co/RNSbdGp/rotated-right-arrow-pngrepo-com.png" className="img-fluid"/>
                    </div>
                    <div className="col-12 col-md-4 ml-auto my-auto order-0 order-md-0 ">
                    
                    <h2 className="message-title mt-5 mt-md-0  mb-2">رسالتنا</h2>
                    
                    </div>
                    </div> */}

                    {/* <div className="col-12 col-md-4 ml-auto">
                    <div className="twenty-thirty-p">
                    <p>تقديم خدمات إسنادية وحلول استشارية للمشاريع المتوسطة والصغيرة.</p>
                    </div>
                    </div> */}
                    {/* <div className="col-12 col-md-6 message overflow-hidden">
                    <h2 className="">رؤيتنا</h2>
                    </div>
                    <div className="col-12 col-md-6 vision-card vision">
                    <p>أن نكون من أوائل الشركات الرائدة في قطاع إسناد الخدمات، وتسريع الأعمال.
                    </p>
                    </div>
                    <div className="col-12 col-md-6 message order-1  overflow-hidden">
                    <h2 className="">رسالتنا</h2>
                    </div>
                    <div className="col-12 col-md-6 vision-card vision order-0">
                    <p>تقديم خدمات إسنادية وحلول استشارية للمشاريع المتوسطة والصغيرة.</p>
                    </div>
 */}
                </div>
            </div>
        </div>
    )
}
